export const Clipboard = (function(window, document, navigator) {
    var textArea,
        copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range,
            selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, text.length);
            alert('is ios!')
        } else {
            textArea.select();
        }
    }

    function copyToClipboard() {        
        const result = document.execCommand('copy');
        if (result) alert('true')
        else alert('false')
        document.body.removeChild(textArea);
    }

    copy = function(text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
    };

    return {
        copy: copy
    };
})(window, document, navigator);

export const REPORT_HREF_LIST = [
    "https://www.twentythree.com.tw/pages/dontkjoanne",
    "https://www.twentythree.com.tw/pages/cacabeall",
    "https://www.twentythree.com.tw/pages/fang",
    "https://twentythree.shoplineapp.com/pages/zora",
    "https://twentythree.shoplineapp.com/pages/ariel",
    "https://www.twentythree.com.tw/pages/233abcd",
    "https://www.twentythree.com.tw/pages/233ab",
    "https://www.twentythree.com.tw/pages/233abcdef",
    "https://www.twentythree.com.tw/pages/twentythree23",
    "https://www.twentythree.com.tw/pages/recycletwentythree",
    "https://www.twentythree.com.tw/pages/23preloved",
    "https://www.twentythree.com.tw/pages/recycle23",
    "https://www.twentythree.com.tw/pages/recycle",
    "https://www.twentythree.com.tw/pages/23refashion",
    "https://www.twentythree.com.tw/pages/23refashion23",
    "https://www.twentythree.com.tw/pages/recycletwentythree23",
    "https://www.twentythree.com.tw/pages/secondhandrecycle",
    "https://www.twentythree.com.tw/pages/twentythreepreloved",
    "https://www.twentythree.com.tw/pages/ssecondhandrecyclee23",
    "https://www.twentythree.com.tw/pages/233ssecond",
    "https://www.twentythree.com.tw/pages/233ssecondreclye",
    "https://www.twentythree.com.tw/pages/refashion23",
    "https://www.twentythree.com.tw/pages/preloved23",
    "https://www.twentythree.com.tw/pages/twentythreesecondhand",
    "https://www.twentythree.com.tw/pages/twentythreerefashion",
    "https://www.twentythree.com.tw/pages/secondhandrecyclee23",
    "https://www.twentythree.com.tw/pages/23recycle23",
    "https://www.twentythree.com.tw/pages/23secondhand",
    "https://www.twentythree.com.tw/pages/23ssecondhandrecyclee23",
    "https://www.twentythree.com.tw/pages/23recycletwentythree23",
    "https://www.twentythree.com.tw/pages/secondhand",
    "https://www.twentythree.com.tw/pages/23recycle",
    "https://www.twentythree.com.tw/pages/secondhand23",
    "https://www.twentythree.com.tw/pages/secondhandrecyclee",
    "https://www.twentythree.com.tw/pages/23ssecondhandrecyclee2233",
    "https://www.twentythree.com.tw/pages/233ssecondhand",
    "https://www.twentythree.com.tw/pages/233abc",
    "https://www.twentythree.com.tw/pages/233abcde",
    "https://www.twentythree.com.tw/pages/233abcdefg",
    "https://www.twentythree.com.tw/pages/233abcdefgh",
]
